<template>
  <div style="padding: 0.22rem">
    <div>
      <div class="left_title">器材管理</div>
      <div class="left_tab left_tab_select">
        发布的租赁信息
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, defineProps, onMounted, defineEmits } from "vue";
import { useRouter } from "vue-router";
const router = useRouter();
const clickclikc = ref('')
const menuList = ref([
  {
    name: '免责声明',
    value: 'mzsm'
  },
  {
    name: '社区指导原则',
    value: 'sqzdyz'
  },
]);
const props = defineProps({
  left_tabShow: String,
});
onMounted(() => {
  clickclikc.value = props.left_tabShow ? props.left_tabShow : ''
})
const emit = defineEmits(['back'])
//直接跳转
const selectcheck = (type: string) => {
  console.log("dianji ", type);
  clickclikc.value = type
  emit('back',clickclikc.value)
};
</script>

<style scoped>
.left_title {
  font-size: 0.12rem;
  margin-bottom: 0.2rem;
  color: #86909c;
}

.left_tab {
  font-size: 0.14rem;
  margin-bottom: 0.2rem;
  color: #333333;
  cursor: pointer;
}

.left_tab_select {
  color: #C01A26;
}
</style>
